import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["modal"];

  toggleModel(e) {
    e.preventDefault()
    this.modalTarget.classList.toggle('close')
  }
}
